import { WORKFLOW_IDS } from "@intelligems/ig-plugin/utils/workflow-ids";
import { ChatHistoryIndex } from "@intelligems/ig-types/schemas/ai/chat-history";
import { aiApiClient } from "@src/api/ai-api";
import { aiSitewideAnalyticsKeys } from "@src/api/queryKeys";
import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { getAiChat } from "@src/store/slices/aiChat";

interface UseGetSitewideAnalyticsChatHistoryOptions {
  orgId: string | null | undefined;
  enabled?: boolean;
}

const getSitewideAnalyticsChatHistory = async (): Promise<
  ChatHistoryIndex[]
> => {
  const response = await aiApiClient.get<ChatHistoryIndex[]>(
    "/chat-history/user/sessions"
  );
  return (response.data ?? []).filter(
    (session) =>
      session.workflowId === WORKFLOW_IDS.SITEWIDE_ANALYTICS_SUMMARY_CHAT
  );
};

export const useGetSitewideAnalyticsChatHistory = ({
  orgId,
  enabled = true,
}: UseGetSitewideAnalyticsChatHistoryOptions) => {
  return useQuery<ChatHistoryIndex[], Error>({
    queryKey: aiSitewideAnalyticsKeys.chatHistory(orgId!),
    queryFn: getSitewideAnalyticsChatHistory,
    enabled: enabled && !!orgId,
  });
};
